/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import Header from 'containers/Header';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import * as siteActions from 'actions/siteActions';
import Errors from 'containers/Errors';
import Vehcile from 'containers/Vehicle';
import userManager, { getUser, isLoadingUser } from 'utils/userManager';
import Drawer from 'material-ui/Drawer';
import MainNavigation from 'layoutComponents/MainNavigation';
import RouteWithSubRoutes from '../RouteWithSubRoutes';
import Loading from 'layoutComponents/Loading';
import AppBar from 'material-ui/AppBar';
import localForage from 'localforage';
const apiUrls = require('../constants/apiUrls');

export class App extends React.Component {

    componentDidMount() {
        const { location } = this.props;

        if (location.search && location.search.includes(apiUrls.ONE_LOGIN)) {

            localStorage.clear();

            const appStore = localForage.createInstance({ name: "app_store" });
            const tokenStore = localForage.createInstance({ name: "token_store" });
            const userStore = localForage.createInstance({ name: "user_store" });

            return appStore
                .clear()
                .then(() => {
                    return tokenStore
                        .clear()
                        .then(() => {
                            return userStore
                                .clear()
                                .then(() => {
                                    userManager.signinRedirect({
                                        data: {
                                            redirectUrl: location.pathname
                                        }
                                    });

                                });
                        });
                });
        }
    }

    getTheme(site) {
        let theme = {};
        const themeModifier = site.get('themeModifier');
        if (themeModifier) {
            theme = getMuiTheme(site.get('themeModifier').toJS());
        } else {
            theme = getMuiTheme();
        }
        if (theme.appBar) {
            theme.appBar.height = 50;
        }
        return theme;
    }

    render() {
        const { oidc, siteActions, site, routes } = this.props;

        const user = getUser(oidc);
        const userLoading = isLoadingUser(oidc);

        return (
            <MuiThemeProvider muiTheme={this.getTheme(site)}>

                <div>
                    {user ?
                        <Header />
                        :
                        <AppBar
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0
                            }}
                        />
                    }
                    <Drawer
                        docked={false}
                        open={site.getIn(['drawers', 'leftDrawer'])}
                        onRequestChange={() => siteActions.toggleDrawer('leftDrawer')}>
                        <div className="wow-fst-left-side-bar-container">
                            {user && <MainNavigation toggleDrawer={siteActions.toggleDrawer} />}
                        </div>
                    </Drawer>
                    <div className="container">
                        <div className="row">
                            <div className="col s12 offset-m2 m8 offset-l3 l6 offset-xl4 xl4">
                                <Vehcile />
                                <Errors />
                                <Loading message="Loading..." isLoading={userLoading} />
                                {routes.map((route, i) => (<RouteWithSubRoutes key={i} user={user} {...route} />))}
                            </div>
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    oidc: PropTypes.object,
    site: PropTypes.object,
    siteActions: PropTypes.object,
    routes: PropTypes.array,
    location: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        oidc: state.get('oidc'),
        message: state.get('message'),
        site: state.get('site'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        siteActions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));



// WEBPACK FOOTER //
// ./src/containers/App.js